import React from "react";
import { Box, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./HelpPopup.module.css";
import callbackUrl from "../../Assets/callBackUrl.svg";
import callback1 from "../../Assets/callback1.png";
import callback2 from "../../Assets/callback2.png";

const CallbackUrlPopup = (props: any) => {
  const { isOpen, onClose } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      sx={{
        zIndex: "99999",
        minWidth: "400px",
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "750px",
          maxHeight: "580px",
          minHeight: "454px",
          padding: "24px",
          borderRadius: "12px",
          boxShadow:
            "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
          left: "5%",
          top: "8%",
          background: "#FFFFFF",
          overflow: "hidden",
        },
      }}
    >
      <div>
        <div className={styles.closeModalButton}>
          <CloseIcon sx={{ color: "#555555" }} onClick={handleClose} />
        </div>
        <div className={styles.modalHead}>
          Not sure what to do with the Callback URL?
        </div>
        <div className={styles.modalSubHead}>Follow these steps:</div>
        <ul className={styles.stepsToFollow}>
          <li>Login to your Voxbay Admin account.</li>
          <li>Click on Developer option on left drawer tab.</li>
          <li>Select Api Management.</li>
          <li>Select CDR tab.</li>
          <li>
            Change from GET to POST and Paste the Callback URL in Incoming Call
            section
          </li>
          <li>Scroll to bottom</li>
          <li>
            Change from GET to POST and Paste the Callback URL in Outgoing Call
            section
          </li>
          <li>Save.</li>
        </ul>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            marginBottom: "10px",
          }}
        >
          <img
            src={callback1}
            alt="apiKey"
            style={{
              width: "100%",
              maxWidth: "100%",
              maxHeight: "200px",
              objectFit: "contain",
            }}
          />
        </Box>
        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "flex-start" }}
        >
          <img
            src={callback2}
            alt="apiKey"
            style={{
              width: "100%",
              maxWidth: "100%",
              maxHeight: "200px",
              objectFit: "contain",
              marginBottom: "20px",
            }}
          />
        </Box>
      </div>
    </Dialog>
  );
};
export default CallbackUrlPopup;
